export default "__VITE_ASSET__Bhh07HyP__"